import { Checkbox, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { openDialog } from "../../../features/dialog";

function SubscriberTable({subscribers, selection, setSelection}){
    const dispatch = useDispatch();
    
    const toggleSelect = id => {
        let _selection = [];
        if(selection.indexOf(id)!==-1){
            _selection = selection.filter(s => s !== id);
        }else{
            _selection = [
                ...selection,
                id
            ]
        }
        setSelection(_selection);
    }
    return <>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>
                        <Checkbox 
                            checked={selection.length > 0}
                            indeterminate={selection.length > 0 && selection.length != subscribers.length} 
                            onChange={(e) => {
                                if(e.target.checked){
                                    setSelection(subscribers.map(r => r.id));
                                }else{
                                    setSelection([])
                                }
                            }}
                        />
                    </TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Subscription Type</TableCell>
                    <TableCell width={140}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {subscribers.map((subscriber,i) => {                    const selected = selection.indexOf(subscriber.id) !== -1;
                    return <TableRow key={i} hover>
                        <TableCell>
                            <Checkbox checked={!!selected} onChange={() => toggleSelect(subscriber.id)} />
                        </TableCell>
                        <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                        }}>
                            {subscriber.user ? subscriber.user.user_full_name : "--"}
                        </TableCell>
                        <TableCell>{subscriber.user ? subscriber.user.email : "--"}</TableCell>
                        <TableCell>{subscriber.subscription}</TableCell>
                        
                        <TableCell align="right">
                            <Tooltip title="Edit">
                                <IconButton size="small" onClick={() => {
                                    dispatch(openDialog({id: "editSubscriber", props: subscriber.id}));
                                }}><Edit /></IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <IconButton size="small"  onClick={() => {
                                    dispatch(openDialog({id: "deleteSubscriber", props: subscriber.id}));
                                }}><Delete /></IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                })}
            </TableBody>
        </Table>
    </>
}

export default SubscriberTable;